// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"97167b0e","80":"fc0ac416","236":"5db7e3ce","243":"ffdc14f9","310":"b690eccf","352":"361e47a1","385":"9aceef88","411":"a6dd9908","529":"07d20a10","623":"ae857522","665":"7a46422b","700":"4f9ce3c3","715":"c5e3d1a5","892":"1db78500"}[chunkId] + ".chunk.js";
};